import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export interface SearchBarTemplateProps {
    autosuggestEndpoint?: string;
    quickLinksEndpoint?: string;
    buttonText?: string;
    navTabContainerSelector?: string;
    placeholder?: string;
    resultsLabel?: string;
    resultTabContainerSelector?: string;
    searchFormSelector?: string;
    searchString?: string;
    _slot?: string;
}

export const SearchBarTemplate = ({
    autosuggestEndpoint,
    quickLinksEndpoint,
    buttonText,
    navTabContainerSelector,
    placeholder,
    resultsLabel,
    resultTabContainerSelector,
    searchFormSelector,
    searchString,
    _slot = "",
}: SearchBarTemplateProps) => html`
    <ux-iws-search-bar
        button-text=${ifDefined(buttonText)}
        placeholder=${ifDefined(placeholder)}
        search-string=${ifDefined(searchString)}
        search-form-selector=${ifDefined(searchFormSelector)}
        nav-tab-container-selector=${ifDefined(navTabContainerSelector)}
        result-tab-container-selector=${ifDefined(resultTabContainerSelector)}
        autosuggest-endpoint=${ifDefined(autosuggestEndpoint)}
        quick-links-endpoint=${ifDefined(quickLinksEndpoint)}
        results-label=${ifDefined(resultsLabel)}
    >
        ${typeof _slot === "string" ? unsafeHTML(_slot) : _slot}
    </ux-iws-search-bar>
`;

export const slotTabs = `
<!-- BEGIN nav tabs -->
<ux-tab-container
    id="search-nav-tabs"
    active-tab-id="tab-pages"
>
    <ux-tab name="Alle Ergebnisse (99)" tab-id="tab-pages"></ux-tab>
    <ux-tab name="Produkte (4)" tab-id="tab-products"></ux-tab>
</ux-tab-container>
<!-- END nav tabs -->
`;

export const slotGPT = `
<!-- BEGIN GPT button -->
<ux-button
    variant="primary"
    data-search-tab="tab-gpt"
    slot="buttons"
>
    TRUMPF&nbsp;GPT&nbsp;<sup>Beta</sup>
</ux-button>
<ux-icon name="square-info" slot="buttons"></ux-icon>
<ux-tooltip
    tooltip-target="ux-icon[name=square-info]"
    slot="buttons"
>
    This text briefly explains what the user can expect
    when clicking the TRUMPF&nbsp;GPT button.
</ux-tooltip>
<!-- END GPT button -->
<!-- BEGIN nav tabs -->
<ux-tab-container
    id="search-nav-tabs"
    active-tab-id="tab-pages"
>
    <ux-tab
        name="Alle Ergebnisse (99)"
        tab-id="tab-pages"
    ></ux-tab>
    <ux-tab name="" tab-id="tab-gpt">
        <span slot="label">
            TRUMPF GPT&nbsp;<sup>Beta</sup>
        </span>
    </ux-tab>
</ux-tab-container>
<!-- END nav tabs -->
`;
